export default "__VITE_ASSET__DSJ$GwEt__"